export default __webpack_public_path__ + "static/media/PLANET4_logo_PLANET4.2ef5fb0a.png";